// extracted by mini-css-extract-plugin
export default {"products":"Hu-z","card":"Iu-z","oosMessaging":"Ju-z"};